<script setup>
import { onBeforeUnmount, ref, watch } from 'vue'
import { activityApi } from '../api'
import ActivityDetailModal from '../components/modals/ActivityDetailModal.vue'
import ActivityHistoryRecovery from '../components/activities/ActivityHistoryRecovery.vue'
import { memberSession } from '../api/session'
import { useWebActivity } from '../services/activities/webAdapter.js'

const props = defineProps({ activityId: { type: String, default: '' } })
const emit = defineEmits(['navigate', 'login'])
const categories = ref([])
const tag = ref('')
const activities = ref([])
const activity = ref(null)
const loading = ref(false)
const error = ref('')
const recoveringHistory = ref(false)
const { getAuth, isLoggedIn } = useWebActivity()
let sequence = 0
async function load() {
  const current = ++sequence
  recoveringHistory.value = false
  loading.value = true; error.value = ''; activity.value = null; activities.value = []
  try {
    if (props.activityId) {
      const result = await activityApi.detail(props.activityId)
      if (current === sequence) {
        if (!result?.id) throw new Error('活动不存在或已结束')
        activity.value = result
      }
    } else {
      const [groups, rows] = await Promise.all([activityApi.categories(), activityApi.list(tag.value)])
      if (current !== sequence) return
      if (!Array.isArray(groups) || !Array.isArray(rows)) throw new Error('活动加载失败，请重试')
      categories.value = groups; activities.value = rows
    }
  } catch (cause) { if (current === sequence) error.value = cause.message }
  finally { if (current === sequence) loading.value = false }
}
watch([() => props.activityId, tag, memberSession, () => isLoggedIn?.value, () => getAuth()?.memberId], load, { immediate: true })
onBeforeUnmount(() => { ++sequence })
</script>
<template>
  <div class="container member-page activity-route-page">
    <div class="member-actions"><button class="outline-button" @click="emit('navigate', props.activityId ? '/activity/discount' : '/')">{{ props.activityId ? '← 优惠活动' : '← 首页' }}</button><button class="outline-button" @click="emit('navigate', '/mine/prizes')">我的奖品</button><button class="outline-button" :disabled="loading" @click="load">刷新</button></div>
    <h1>{{ activity?.title || (activityId ? '活动详情' : '优惠活动') }}</h1>
    <p v-if="loading" role="status">活动加载中…</p>
    <section v-else-if="error" class="activity-load-error">
      <p role="alert" class="request-error">{{ error }}</p>
      <div class="member-actions"><button type="button" @click="load">重试</button><button v-if="activityId && !recoveringHistory" type="button" @click="recoveringHistory = true">查询原参与记录</button></div>
      <ActivityHistoryRecovery v-if="activityId && recoveringHistory" :activity-id="activityId" />
    </section>
    <template v-else-if="activity">
      <ActivityDetailModal :activity="activity" :inline="activity.presentation?.contentMode === 'REGULAR'" @close="emit('navigate', '/activity/discount')" />
    </template>
    <template v-else>
      <nav class="member-actions" aria-label="活动分类"><button v-for="category in categories" :key="category.activityTag" class="outline-button" :aria-pressed="tag === category.activityTag" @click="tag = category.activityTag">{{ category.name }}</button></nav>
      <div class="activity-grid"><article v-for="item in activities" :key="item.id" class="member-panel"><img v-if="item.coverUrl" class="activity-cover" :src="item.coverUrl" :alt="item.title" /><p>{{ categories.find((category) => category.activityTag === item.activityTag)?.name || '' }}</p><h2>{{ item.title }}</h2><button class="primary" @click="emit('navigate', `/activity/${item.id}`)">查看活动与奖品</button></article></div>
      <p v-if="!activities.length">当前分类暂无活动。</p>
    </template>
  </div>
</template>

<style scoped>
.activity-route-page { padding-top: 108px; }
@media (max-width: 999px) { .activity-route-page { padding-top: 98px; } }
</style>
